const LOAD_DATA_XPERT           = 'LOAD_DATA_XPERT'
const LOAD_DATA_XPERT_SUCCESS   = 'LOAD_DATA_XPERT_SUCCESS'
const LOAD_DATA_XPERT_FAILED    = 'LOAD_DATA_XPERT_FAILED'
const UNMOUNT_DATA_XPERT        = 'UNMOUNT_DATA_XPERT'
const initialState = {
  loading: true,
  meta: null,
  data: null,
  message: null,
}
const xpertReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_XPERT:
      return {
        ...state,
        loading: true,
        meta: null,
        data: null,
      }
    case LOAD_DATA_XPERT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        meta: action.payload.meta,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_XPERT_FAILED:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_XPERT:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
      }
    default:
      return state
  }
}
export default xpertReducer;